import React from 'react';
import styles from './EmptyState.module.scss';
import emptyStateImage from '../../../../../Assets/Images/noData.svg';

const EmptyState = ({ onClearFilters }) => {
    return (
        <div className={styles.emptyStateContainer}>
            <img src={emptyStateImage} alt="No tickets found" className={styles.emptyStateImage} />
            <h2>No Tickets Found</h2>
            <p>Try adjusting your search or filter to find what you're looking for.</p>
            <button onClick={onClearFilters} className={styles.clearButton}>Clear Filters</button>
        </div>
    );
};

export default EmptyState;